import React, { useMemo, useState, useCallback } from 'react'
import {
  useResponsiveWrapperContext,
} from '@usap/uicomponents'
import captchConfig from '../../../../../../config/captcha-config'
import useAddToCartPL from './hooks/useAddToCartPL'
import Component from './Component'

const { siteKey } = captchConfig

const AddButtonForPL = props => {
  const {
    cardId,
    onClickNotify,
    index,
    data,
    invObj,
    groundDeliveryTime,
    pageType,
    onError,
    widgetName,
    executeEcomATCEvent
  } = props

  const {
    id: invId,
  } = { ...data }

  const { isDesktop } = useResponsiveWrapperContext()
  const [notify, setNotify] = useState(false)
  const [cartLoading, setCartLoading] = useState(false)
  const isNotAvailable = invObj && !invObj.available

  const addToCartHandler = useAddToCartPL({
    index,
    data,
    isNotAvailable,
    setNotify,
    setCartLoading,
    invObj,
    groundDeliveryTime,
    pageType,
    widgetName,
    executeEcomATCEvent
  })

  const handleAddToCart = useCallback(async () => {
    try {
      await addToCartHandler()
    } catch (e) {
      onError()
    }
  }, [addToCartHandler, onError])

  const componentData = useMemo(() => ({
    cartLoading,
    notify,
    isDesktop,
    invId,
    onClickNotify,
    cardId,
    siteKey,
    setNotify,
    index,
    isNotAvailable,
    widgetName,
    onAddToCart: handleAddToCart,
  }), [
    cartLoading,
    notify,
    isDesktop,
    invId,
    onClickNotify,
    cardId,
    index,
    isNotAvailable,
    widgetName,
    handleAddToCart,
  ])

  return (
    <Component data={componentData} />
  )
}

export default AddButtonForPL
